import React, { useState } from 'react'
import {
  List,
  Filter,
  useListRepository,
  useFilter,
  TextField,
  Select
} from 'elentari'
import { Field } from 'react-final-form'
import Grid from '@material-ui/core/Grid'
import { withStyles, Fab, Tooltip, CircularProgress } from '@material-ui/core'
import Sync from '@material-ui/icons/Sync'
import mercadoriaRepository from './MercadoriaRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import { useHistory } from 'react-router-dom'
import EmpresaSelect from '../Empresa/EmpresaSelect'

const styles = theme => ({
  fab: {
    position: 'fixed',
    right: theme.spacing(4),
    bottom: theme.spacing(4)
  }
})

const MercadoriaFilter = () => {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição"
            component={TextField}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <EmpresaSelect />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            hideEmpty
            component={Select}
            options={[
              { label: 'Ativo', value: true },
              { label: 'Inativo', value: false }
            ]}
            label="Status"
            name="ativo"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Mercadorias = ({ classes, ...props }) => {
  const [fetching, setFetching] = useState(false)
  const history = useHistory()

  const [ability] = useAbility()
  const listOptions = {
    defaultOrder: 'id',
    fields: {
      id: {
        label: 'Id'
      },
      descricao: {
        label: 'Descricao'
      },
      empresa: {
        label: 'Empresa',
        format: empresa => (empresa ? empresa.nome : '')
      },
      ativo: {
        label: 'Status',
        format: value => (value ? 'Ativo' : 'Inativo')
      }
    }
  }

  const listHook = useListRepository({
    repository: mercadoriaRepository,
    path: 'mercadorias'
  })
  const actions = getListActions(ability, listHook, 'mercadorias')

  const handleSync = async () => {
    setFetching(true)
    await mercadoriaRepository.sync()
    await listHook.fetchList()
    setFetching(false)
  }

  const handleClickEdit = item =>
    history.push(`/mercadorias/${item.id}${history.location.search}`)

  return (
    <>
      <MercadoriaFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickEdit={handleClickEdit}
        onClickView={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
      <Tooltip title="Sincronizar">
        <Fab
          aria-label="Sincronizar"
          className={classes.fab}
          color="secondary"
          onClick={handleSync}
        >
          {fetching ? <CircularProgress size={24} color="inherit" /> : <Sync />}
        </Fab>
      </Tooltip>
    </>
  )
}

export default withStyles(styles)(Mercadorias)
